import { EnrollmentCallOutcome } from '@zorro/clients';
import * as yup from 'yup';

export const enrollmentCallOutcomeLabels: Record<
  EnrollmentCallOutcome,
  string
> = {
  [EnrollmentCallOutcome.CANCELED]: 'Canceled',
  [EnrollmentCallOutcome.NO_SHOW]: 'No-show',
  [EnrollmentCallOutcome.ELECTED_PLAN]: 'Elected plan',
  [EnrollmentCallOutcome.UNDECIDED]: 'Undecided',
};

export const logEnrollmentCallSchemaObject = yup.object().shape({
  calledWith: yup
    .string()
    .trim()
    .max(255)
    .required('Who the call was with is required'),
  outcome: yup
    .mixed<EnrollmentCallOutcome>()
    .oneOf(Object.values(EnrollmentCallOutcome))
    .required('Outcome is required'),
  notes: yup.string().nullable(),
});

export type LogEnrollmentCallFormFields = yup.InferType<
  typeof logEnrollmentCallSchemaObject
>;

export type EnrollmentCallActorRole = 'operator' | 'agent';
